import React from 'react';
import { config } from '../config';

function CharityWallet() {
  return (
    <div className='px-4 pb-12 mx-auto md:rounded-lg max-w-7xl sm:px-6 lg:pb-12 lg:pt-12 lg:px-8'>
      <div className='max-w-3xl mx-auto text-center'>
        <div className='lg:text-center'>
          <p className='mt-2 text-3xl font-bold leading-8 tracking-tight text-gray-100 sm:text-4xl'>Charity Wallet</p>
          <p className='max-w-xl mt-4 text-xl text-gray-500 lg:mx-auto'>
            You can scan the QR code or copy the address below. Thank you so much for your donation!
          </p>
        </div>

        <div className='mx-auto mt-10 max-w-[350px]'>
          <img src='/charity-qr-code.png' alt='Charity QR Code' />
        </div>

        <div className='w-full mt-10 overflow-hidden prose flex justify-center mx-auto'>
          <pre className='inline-flex p-3 text-center rounded-md bg-dropdown'>{config.charityWallet}</pre>
        </div>

        <div className='mt-8'>
          <a href={`https://allo.info/account/${config.charityWallet}`} target='_blank' rel='noreferrer' className='font-bold text-primary-500'>
            View on Allo
          </a>
        </div>
      </div>
    </div>
  );
}

export default CharityWallet;
